import { TeamBasicInfoWithSize } from './team-basic-info-with-size';


export class ChatbotAvailableTeam {

  private _teamId: string;
  private _creatorId: string;
  private _teamName: string;
  private _teamSize: number;

  constructor(teamId: string,
              creatorId: string,
              teamName: string,
              teamSize: number = 0) {
    this._teamId = teamId;
    this._creatorId = creatorId;
    this._teamName = teamName;
    this._teamSize = teamSize;
  }

  get teamId(): string {
    return this._teamId;
  }

  get creatorId(): string {
    return this._creatorId;
  }

  get teamName(): string {
    return this._teamName;
  }
  get teamSize(): number{
    return this._teamSize;
  }

  static buildFrom(teamBasicInfoRepresentation: TeamBasicInfoWithSize){
    return new ChatbotAvailableTeam(
      teamBasicInfoRepresentation.teamId,
      teamBasicInfoRepresentation.creatorId,
      teamBasicInfoRepresentation.teamName,
      teamBasicInfoRepresentation.teamSize || 0
    );
  }
}
